import { Referral } from "../types/Referral";
import { CheckoutSession } from "../types/Stripe";

export const dynamicsService = {
  createCheckoutSession,
  getReferral,
  updateReferral,
};

export function fetchResponseToJson(response: any) {

  function logout() {
    localStorage.removeItem("token");
  }
  return response.text().then((text: string) => {
    //const data = text && JSON.parse(text, parseWithDate);
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function createCheckoutSession(account_id: string, baseUrl: string): Promise<CheckoutSession> {
  const authHeader = new Headers();
  authHeader.append("Content-Type", "application/json");
  const requestOptions = {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({
      account_id,
      base_url: baseUrl,
    }),
  };
  return fetch(window.serviceProviderConfig.checkoutUrl, requestOptions).then(
    fetchResponseToJson
  );
}


function getReferral(account_id: string, referral_id: string): Promise<Referral> {
  const authHeader = new Headers();
  authHeader.append("Content-Type", "application/json");
  const requestOptions = {
    method: "GET",
    headers: authHeader,
  };
  const url = `https://prod-15.northcentralus.logic.azure.com/workflows/1a873ff1d6124f24ac786765c7c1f1a0/triggers/manual/paths/invoke/account/${account_id}/referral/${referral_id}?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=Y2BG_8Dqrv1qKrK0rIqP5LOI3DwQSSJbPHo8jhn2GcA`;
  return fetch(url, requestOptions).then(
    fetchResponseToJson
  );
}



function updateReferral(referral_id: string, action: string): Promise<string> {
  const authHeader = new Headers();
  authHeader.append("Content-Type", "application/json");
  const requestOptions = {
    method: "GET",
    headers: authHeader,
  };
  const url = `https://prod-02.westus.logic.azure.com/workflows/23ce1e22663845258500f1cf1d983456/triggers/manual/paths/invoke/action/${action}/referralid/${referral_id}?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=hT7doYpE9t0PsKERcVFalOAQcAgdOor8rHvOJMhjIkc`;
  return fetch(url, requestOptions).then(
    response => {
      if (!response.ok) {
        return Promise.reject(response.text());
      }
      return response.text();
    }
  );
}